import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IonicPage, NavController, MenuController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

//Providers
import { SBSuiteManager } from '../../modules/sbsuite/providers/sbsuite.manager';

//Decorators
//import { DisableSideMenu } from '../../decorators/disable-side-menu.decorator';

/**
 * Componente de la página de login.
 *
 * @export
 * @class Login
 */
//@DisableSideMenu()
@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class Login {


  /**
   * Formulario de usuario/password.
   *
   * @type {FormGroup}
   * @memberof Login
   */
  form : FormGroup;


  /**
   * Modelo de datos de usuario/password.
   *
   * @type {{username: string, password: string}}
   * @memberof Login
   */
  credentials: {username: string, password: string} = {username:'', password:''};


  /**
   * Crea una instancia de Login.
   * 
   * @param {NavController} navCtrl //Control de navegación.
   * @param {FormBuilder} formBuilder //Servicio de constructor de formulario.
   * @param {SBSuiteManager} sbSuiteManager //Gestor de sbSuite.
   * @param {TranslateService} _translateService //Servicio de traducciones.
   * @memberof Login
   */
  constructor(
    public navCtrl: NavController,
    public menuCtrl: MenuController,
    private formBuilder: FormBuilder,
    private sbSuiteManager: SBSuiteManager,
    private _translateService: TranslateService
    
  ) {
    this.initForm();

  }

  ionViewDidEnter(){
    this.menuCtrl.enable(false);
  }

  ionViewDidLeave(){

    let view = this.navCtrl.first();
    if(!(view.instance instanceof Login)) this.menuCtrl.enable(true);
  }

  /**
   * Inicia el formulario.
   *
   * @memberof Login
   */
  initForm(): void{

    this.form = this.formBuilder.group({
        username:  [this.credentials.username, []],
        password: [this.credentials.password, []]
    });
  
  }

  /**
   * Activa el submit del formulario.
   *
   * @returns {boolean} True si los datos són válidos.
   * @memberof Login
   */
  isAllowed(): boolean{
    return true;
  }


  /**
   * Valida los datos de formulario.
   *
   * @memberof Login
   */
  fromControl(){
    this.credentials.username = this.form.controls.username.value;
    this.credentials.password = this.form.controls.password.value;
    if(this.credentials.username.toLocaleLowerCase() == 'admin') this.sbSuiteManager.isAdmin = true;
    else this.sbSuiteManager.isAdmin = false;
    this.sbSuiteManager.isAuth = true;
    this.sbSuiteManager.login(this.credentials);
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts